/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  // Check if user is authenticated
  if (loading) {
    return null; // Show nothing while loading
  }

  if (!userProfile || !token) {
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  // Check if user is admin
  // Handle different user profile structures
  let user = null;
  if (userProfile.user) {
    user = userProfile.user;
  } else if (userProfile && typeof userProfile === 'object') {
    // If userProfile itself is the user object
    user = userProfile;
  }

  if (!user || !user.isAdmin) {
    // Logout non-admin users and redirect to login
    dispatch(logoutUser());
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
